import React from 'react';
import PropTypes from 'prop-types';
import {
    CurrentAccommodationSearchSessionStorage,
    TrackingUtils,
    withPageContext,
} from '../../utils';
import { LocationProp } from '../../models';
import { DropdownItem } from '../../components/DropdownItem/DropdownItem';
import { HSA_SEARCH_FORM_POPULAR_DESTINATION_CLICK, withClickTrack } from '../../utils/HtmlEvents';
import { useSearchId } from '../SearchManager/SearchIdProvider';

const PopularHotelsDestinationsItem = ({ index, item, onClickItem, trackEvent }) => {
    const { updateSearchId } = useSearchId();
    const getMainText = () => {
        return (
            <div className="odf-row">
                <div className="odf-text-ellipsis">{item.name}</div>
            </div>
        );
    };
    const getDescriptionText = () => {
        let descriptionText = '';
        if (item.region && item.country) {
            descriptionText = ` ${item.region}, ${item.country}`;
        } else if (item.region && !item.country) {
            descriptionText = `${item.region}`;
        } else if (!item.region && item.country) {
            descriptionText = `${item.country}`;
        }
        return (<div className="odf-dropdown-extra">{descriptionText}</div>);
    };

    const _onClickItem = () => {
        const label = TrackingUtils.LABEL.hotelPopularDestinationLabel(index + 1);

        trackEvent({
            action: TrackingUtils.ACTION.HOTELS,
            label
        });
        CurrentAccommodationSearchSessionStorage.setSegment({
            destination: item,
        });
        updateSearchId();
        onClickItem(item);
    };

    const DropdownItemElem = withClickTrack(({ onClick }) => {
        return (
            <DropdownItem
                onClick={onClick}
                iconClass="odf-icon-location"
                isFixedWidth={false}
                isShowIcon
            >
                {getMainText()}
                {getDescriptionText()}
            </DropdownItem>
        );
    });
    return (
        <DropdownItemElem
            onClick={_onClickItem}
            html-event-id={HSA_SEARCH_FORM_POPULAR_DESTINATION_CLICK}
        />
    );
};

PopularHotelsDestinationsItem.propTypes = {
    index: PropTypes.number.isRequired,
    onClickItem: PropTypes.func.isRequired,
    item: LocationProp.isRequired,
    trackEvent: PropTypes.func.isRequired,
};

const withContext = withPageContext(PopularHotelsDestinationsItem);
export { withContext as PopularHotelsDestinationsItem };
